import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServicoService } from '../../../services/servico.service';
import { RecadastroService } from '../../../services/Recadastro.service';
import { formularioService } from '../../../../colaborador/services/formulario.service';
import { AuthService } from '../../../../../services/auth.service';
import { ValidationBusService } from '../../../../../shared/services/validation-bus.service';
import { Subscription } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare var L: any;

@Component({
    selector: 'app-servico-detalhes',
    standalone: false,
    templateUrl: './servico-detalhes.component.html',
    styleUrls: ['./servico-detalhes.component.css']
})
export class ServicoDetalhesComponent implements OnInit, OnDestroy {
    servico: any = null;

    get servicoDetalhes() { return this.servico; }

    get CadastroSelecionado() { return this.servico; }

    get dataCadastroLabel(): string {
        return this.tipo === 'recadastro' ? 'Data Recadastramento' : 'Data Cadastro';
    }

    get dataCadastroValue(): string | Date | null {
        if (!this.servico) return null;
        if (this.tipo === 'recadastro') {
            return this.servico.dataRecadastramento || this.servico.dataCadastro || this.servico.dataCadastroOriginal || null;
        }
        return this.servico.dataCadastroOriginal || this.servico.dataCadastro || null;
    }

    get exibirSecaoAgua(): boolean {
        const detalhes = this.servico;
        if (!detalhes) {
            return false;
        }

        const possuiNumeroHidrometro = detalhes.numeroHidrometro !== undefined && detalhes.numeroHidrometro !== null && detalhes.numeroHidrometro !== '';

        return Boolean(
            possuiNumeroHidrometro ||
            detalhes.marcacao ||
            detalhes.seloReloj ||
            detalhes.seloVirola ||
            detalhes.ramal ||
            detalhes.direto !== undefined ||
            detalhes.haCisterna !== undefined ||
            detalhes.haReservatorioElevado !== undefined ||
            detalhes.tipoEconomia ||
            detalhes.haPiscina !== undefined
        );
    }
    erro: string | null = null;
    tipo: 'cadastro' | 'recadastro' = 'cadastro';
    id: string = '';
    mostrarModalInvalida = false;
    motivoInvalido = '';
    motivoInvalidoTouched = false;
    mostrarModalFoto = false;
    fotoSelecionada = '';
    htmlCompletoParaExportar: string = '';
    processandoStatus = false;
    statusProcessado = false;
    statusFinal: 'Validado' | 'Invalido' | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private servicoService: ServicoService,
        private recadastroService: RecadastroService,
        private formularioService: formularioService,
        private spinner: NgxSpinnerService,
        private authService: AuthService,
      private validationBus: ValidationBusService
        ) { }

    private _validationSub?: Subscription;
    private invalidacaoCampos: { [campo: string]: string } = {};
    private autoGeneratedKeys: Set<string> = new Set();
    rotacoesMiniatura: { [url: string]: number } = {};
    rotacaoFoto = 0;

    getRotacaoMiniatura(url: string): number {
        const key = this.getFotoRotacaoKey(url);
        if (this.rotacoesMiniatura[key] !== undefined) return this.rotacoesMiniatura[key];
        const rotacaoSalva = localStorage.getItem(key);
        return rotacaoSalva ? parseInt(rotacaoSalva, 10) : 0;
    }

    girarMiniatura(url: string, direcao: 'esquerda' | 'direita'): void {
        const key = this.getFotoRotacaoKey(url);
        let rot = this.getRotacaoMiniatura(url);
        rot += direcao === 'esquerda' ? -90 : 90;
        rot = ((rot % 360) + 360) % 360;
        this.rotacoesMiniatura[key] = rot;
        localStorage.setItem(key, rot.toString());
    }

    getFotoRotacaoKey(url: string): string {
        return 'foto_rotacao_' + btoa(encodeURIComponent(url));
    }

    girarFoto(direcao: 'esquerda' | 'direita'): void {
        if (direcao === 'esquerda') {
            this.rotacaoFoto -= 90;
        } else {
            this.rotacaoFoto += 90;
        }
        this.rotacaoFoto = ((this.rotacaoFoto % 360) + 360) % 360;
        
        if (this.fotoSelecionada) {
            const key = this.getFotoRotacaoKey(this.fotoSelecionada);
            this.rotacoesMiniatura[key] = this.rotacaoFoto;
            localStorage.setItem(key, this.rotacaoFoto.toString());
        }
    }

        ngOnDestroy(): void {
            if (this._validationSub) {
                this._validationSub.unsubscribe();
            }
        }
    
    ngOnInit(): void {
        this.tipo = (this.route.snapshot.paramMap.get('tipo') as any) || 'cadastro';
        this.id = this.route.snapshot.paramMap.get('id') || '';

        if (!this.id) {
            this.erro = 'ID da vistoria não fornecido.';
            return;
        }
        this.iniciarAnalise();

        // Subscribe to validation bus - append or update motivoInvalido automatically
        try {
            this._validationSub = this.validationBus.onInvalidation().subscribe((evt: any) => {
                if (!evt || !evt.campo) return;
                // If the event contains registroId and tipo, ensure it matches current record
                if (evt.tipo && evt.tipo !== this.tipo) return;

                const campo = String(evt.campo);
                const observacaoRaw = evt.observacao;
                const observacao = observacaoRaw === undefined || observacaoRaw === null ? undefined : String(observacaoRaw).trim();


                if (evt.registroId) {
                    const registroId = String(evt.registroId);
                    const currentRecordId = this.tipo === 'recadastro'
                        ? String(this.servico?.recadastroId || this.servico?.id || '')
                        : String(this.servico?.cadastroId || this.servico?.id || '');

                    // If registroId points to a photo/doc (i.e. not the current cadastro id), try
                    // to attach it to fotos/fotosDocumento. Otherwise fall through to non-photo handling.
                    if (registroId && registroId !== currentRecordId) {
                        let updated = false;
                        try {
                            const fotos = Array.isArray(this.servico?.fotos) ? this.servico.fotos : [];
                            for (const f of fotos) {
                                const fid = String(f?.fotoId || f?.id || '');
                                if (fid && fid === registroId) {
                                    f.validacao = f.validacao || {};
                                    if (observacao) f.validacao.observacao = observacao; else delete f.validacao.observacao;
                                    updated = true;
                                    break;
                                }
                            }
                            if (!updated) {
                                const docs = Array.isArray(this.servico?.fotosDocumento) ? this.servico.fotosDocumento : [];
                                for (const d of docs) {
                                    const did = String(d?.fotoDocumentoId || d?.id || '');
                                    if (did && did === registroId) {
                                        d.validacao = d.validacao || {};
                                        if (observacao) d.validacao.observacao = observacao; else delete d.validacao.observacao;
                                        updated = true;
                                        break;
                                    }
                                }
                            }
                        } catch (err) {
                            // ignore errors while trying to attach to photos
                        }

                        // After attaching to photo/doc (or if not found), rebuild motivo
                        this.updateMotivoInvalidoFromMap();
                        return;
                    }
                    // else fall through: registroId equals current record id -> handle as non-photo
                }

                // Non-photo fields: keep the existing behavior of tracking by campo
                if (!observacao) {
                    if (this.invalidacaoCampos[campo]) {
                        delete this.invalidacaoCampos[campo];
                        this.autoGeneratedKeys.delete(campo);
                        this.updateMotivoInvalidoFromMap();
                    }
                    return;
                }

                this.invalidacaoCampos[campo] = observacao;
                this.autoGeneratedKeys.add(campo);
                this.updateMotivoInvalidoFromMap();
            });
        } catch (e) {
            // not fatal - ignore if the bus isn't available at runtime
        }

        this.spinner.show();
        const call = this.tipo === 'recadastro'
            ? this.servicoService.obterRecadastroPorId(this.id)
            : this.servicoService.obterCadastroPorId(this.id);

        call.subscribe({
            next: (r) => {
                this.servico = r;
                this.spinner.hide();
                // emit current validations to bus so toggles can initialize instantly
                try {
                    const fetchValidacoes = this.tipo === 'recadastro'
                        ? this.servicoService.obterValidacoesRecadastro(this.servico?.recadastroId || this.servico?.id)
                        : this.servicoService.obterValidacoesCadastro(this.servico?.cadastroId || this.servico?.id);
                    fetchValidacoes.subscribe({ next: (validacoes) => {
                        (validacoes || []).forEach((v: any) => {
                            // emit per-item events with registroId and tipo to scope
                            try { this.validationBus.emitInvalidation({ campo: v.campo, observacao: v.observacao, registroId: this.tipo === 'recadastro' ? (this.servico?.recadastroId || this.servico?.id) : (this.servico?.cadastroId || this.servico?.id), tipo: this.tipo }); } catch(e) { /* ignore */ }
                        });
                    }});
                } catch(e) {
                    // ignore emission errors
                }
                // load photos from API and fetch validation flags
                try { this.loadPhotosFromApi(); } catch (e) { /* ignore */ }
                setTimeout(() => this.inicializarMapaServico(), 300);
            },
            error: (err) => {
                this.erro = 'Erro ao carregar detalhes da vistoria.';
                this.spinner.hide();
            }
        });
    

    }

    goBack() {
        this.router.navigate(['/admin/servicos-pendentes']);
    }

    fecharModalDetalhes(): void {
        // When closing the details page, set status back to 'Pendente' before navigating away.
        if (!this.servico) {
            this.goBack();
            return;
        }

        // Avoid double actions
        if (this.processandoStatus) {
            return;
        }

        this.processandoStatus = true;
        this.spinner.show();

        const isRecadastro = this.servico.recadastroId && this.servico.recadastroId !== '00000000-0000-0000-0000-000000000000';
        const id = isRecadastro ? this.servico.recadastroId : this.servico.cadastroId || this.servico.id;
        const adminUsuarioId = this.getAdminUsuarioId();

        const serviceCall = isRecadastro
            ? this.servicoService.atualizarStatusRecadastro(id, 'Pendente', undefined, adminUsuarioId)
            : this.servicoService.atualizarStatusCadastro(id, 'Pendente', undefined, adminUsuarioId);

        serviceCall.subscribe({
            next: () => {
                this.spinner.hide();
                this.processandoStatus = false;
                // cleanup localStorage entry used while analysing
                try { localStorage.removeItem('servicoAnalise'); } catch (e) { /* ignore */ }

                // navigate back after a short delay to show any UI change, then force a reload
                setTimeout(() => {
                    this.goBack();
                    // small delay to allow navigation to complete, then reload the page to refresh lists
                    setTimeout(() => { try { window.location.reload(); } catch (e) { /* ignore */ } }, 200);
                }, 150);
            },
            error: () => {
                // On error, still navigate back but surface a simple error message
                this.spinner.hide();
                this.processandoStatus = false;
                this.erro = 'Erro ao atualizar status para Pendente. Saindo da página.';
                setTimeout(() => {
                    this.goBack();
                    setTimeout(() => { try { window.location.reload(); } catch (e) { /* ignore */ } }, 300);
                }, 500);
            }
        });
    }

    abrirModalFoto(url: string): void {
        this.fotoSelecionada = this.getFullImageUrl(url);
        this.mostrarModalFoto = true;
        this.rotacaoFoto = this.getRotacaoMiniatura(url);
    }

    getFullImageUrl(url: string): string {
        if (!url) return '';
        if (/^https?:\/\//.test(url)) return url;
        return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    }

    fecharModalFoto(): void {
        this.mostrarModalFoto = false;
        this.fotoSelecionada = '';
        this.rotacaoFoto = 0;
    }

    private fetchPhotoValidations(): void {
        if (!this.servico) return;

        // Fotos do local
        const fotos = Array.isArray(this.servico.fotos) ? this.servico.fotos : [];
        fotos.forEach((foto: any) => {
            const id = foto?.id || foto?.fotoId || foto?.foto?.id;
            if (!id) {
                foto.validacao = null;
                return;
            }
            this.servicoService.obterValidacaoFoto(String(id)).subscribe({
                next: (res) => {
                    try {
                        // API may return an array or a single object. If array, try to find matching id
                        if (Array.isArray(res)) {
                            const match = res.find((r: any) => String(r.id || r.fotoId || r.FotoId || '') === String(id));
                            foto.validacao = match || res[0] || null;
                        } else {
                            foto.validacao = res || null;
                        }
                    } catch (e) {
                        foto.validacao = res || null;
                    }
                },
                error: () => { foto.validacao = null; }
            });
        });

        // Fotos de documento
        const fotosDoc = Array.isArray(this.servico.fotosDocumento) ? this.servico.fotosDocumento : [];
        fotosDoc.forEach((fotoDoc: any) => {
            const id = fotoDoc?.id || fotoDoc?.fotoDocumentoId || fotoDoc?.foto?.id;
            if (!id) {
                fotoDoc.validacao = null;
                return;
            }
            this.servicoService.obterValidacaoFotoDocumento(String(id)).subscribe({
                next: (res) => {
                    try {
                        if (Array.isArray(res)) {
                            const match = res.find((r: any) => String(r.id || r.fotoDocumentoId || r.FotoDocumentoId || '') === String(id));
                            fotoDoc.validacao = match || res[0] || null;
                        } else {
                            fotoDoc.validacao = res || null;
                        }
                    } catch (e) {
                        fotoDoc.validacao = res || null;
                    }
                },
                error: () => { fotoDoc.validacao = null; }
            });
        });
    }

    private loadPhotosFromApi(): void {
        if (!this.servico) return;

        const cadastroId = this.servico.cadastroId || this.servico.id || this.servico.recadastroId;
        if (!cadastroId) return;

        // carregar fotos do local
        try {
            this.formularioService.buscarFotosPorCadastro(String(cadastroId)).subscribe({
                next: (fotos) => {
                    // normalizar para um array de objetos com chaves consistentes
                    this.servico.fotos = (fotos || []).map((f: any) => ({
                        fotoId: f.fotoId || f.id || f.FotoId || f.foto || null,
                        url: f.url || f.Url || f.path || f.Path || null,
                        latitude: f.latitude || f.Latitude || null,
                        longitude: f.longitude || f.Longitude || null,
                        validacao: null
                    }));

                    // depois de popular fotos, tentar carregar documentos
                    this.formularioService.buscarFotosDocumentosPorCadastro(String(cadastroId)).subscribe({
                        next: (docs) => {
                            this.servico.fotosDocumento = (docs || []).map((d: any) => ({
                                fotoDocumentoId: d.fotoDocumentoId || d.id || d.FotoDocumentoId || null,
                                url: d.url || d.Url || d.path || null,
                                latitude: d.latitude || d.Latitude || null,
                                longitude: d.longitude || d.Longitude || null,
                                validacao: null
                            }));

                            // por fim, buscar validações para ambos
                            this.fetchPhotoValidations();
                        },
                        error: () => {
                            this.servico.fotosDocumento = this.servico.fotosDocumento || [];
                            this.fetchPhotoValidations();
                        }
                    });
                },
                error: () => {
                    // fallback: manter o que já estava no serviço e ainda tentar validações
                    this.servico.fotos = this.servico.fotos || [];
                    this.formularioService.buscarFotosDocumentosPorCadastro(String(cadastroId)).subscribe({
                        next: (docs) => {
                            this.servico.fotosDocumento = (docs || []).map((d: any) => ({
                                fotoDocumentoId: d.fotoDocumentoId || d.id || d.FotoDocumentoId || null,
                                url: d.url || d.Url || d.path || null,
                                latitude: d.latitude || d.Latitude || null,
                                longitude: d.longitude || d.Longitude || null,
                                validacao: null
                            }));
                            this.fetchPhotoValidations();
                        },
                        error: () => {
                            this.servico.fotosDocumento = this.servico.fotosDocumento || [];
                            this.fetchPhotoValidations();
                        }
                    });
                }
            });
        } catch (e) {
            // se algo falhar, evita quebra
            this.servico.fotos = this.servico.fotos || [];
            this.servico.fotosDocumento = this.servico.fotosDocumento || [];
            try { this.fetchPhotoValidations(); } catch (err) { /* ignore */ }
        }
    }

    validarServico(): void {
        if (!this.servico) return;
        this.processandoStatus = true;
        this.statusFinal = 'Validado';
        this.spinner.show();

        const isRecadastro = this.servico.recadastroId && this.servico.recadastroId !== '00000000-0000-0000-0000-000000000000';
        const id = isRecadastro ? this.servico.recadastroId : this.servico.cadastroId || this.servico.id;

        const adminUsuarioId = this.getAdminUsuarioId(); // novo: pega id do localStorage

        const serviceCall = isRecadastro
            ? this.servicoService.atualizarStatusRecadastro(id, 'Validado', undefined, adminUsuarioId)
            : this.servicoService.atualizarStatusCadastro(id, 'Validado', undefined, adminUsuarioId);

        serviceCall.subscribe({
            next: () => {
                this.spinner.hide();
                this.processandoStatus = false;
                this.statusProcessado = true;
                try { localStorage.removeItem('servicoAnalise'); } catch (e) { /* ignore */ }
                setTimeout(() => this.goBack(), 2000);
            },
            error: () => {
                this.spinner.hide();
                this.processandoStatus = false;
                this.statusProcessado = false;
                this.statusFinal = null;
                this.erro = 'Erro ao validar vistoria. Tente novamente.';
            }
        });
    }

    confirmarValidacao(): void {
        if (!this.servico) return;

        try {
            const fireObj = (window as any).fire;
            if (fireObj && typeof fireObj.swal === 'function') {
                // Support custom fire.swal signature (resolve promise-like)
                fireObj.swal({
                    title: 'Confirmar validação?',
                    text: 'Deseja realmente validar esta vistoria?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, validar',
                    cancelButtonText: 'Cancelar'
                }).then((res: any) => {
                    if (res && (res.isConfirmed || res.value)) {
                        this.validarServico();
                    }
                });
                return;
            }
        } catch (e) {
            // ignore and fallback to Swal
        }

        // Fallback to standard SweetAlert2
        Swal.fire({
            title: 'Confirmar validação?',
            text: 'Deseja realmente validar esta vistoria?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, validar',
            cancelButtonText: 'Cancelar'
        }).then((result: any) => {
            if (result && result.isConfirmed) {
                this.validarServico();
            }
        });
    }

    invalidarServico(): void {
        if (!this.servico) return;
        this.motivoInvalidoTouched = false;
        this.motivoInvalido = '';
        // Fill current auto-generated entries (if any) so the modal shows them
        this.updateMotivoInvalidoFromMap();
        this.mostrarModalInvalida = true;
    }

    confirmarInvalidacao(): void {
        this.motivoInvalidoTouched = true;
        if (!this.motivoInvalido || this.motivoInvalido.trim().length < 3) {
            return;
        }
        this.processandoStatus = true;
        this.statusFinal = 'Invalido';
        this.mostrarModalInvalida = false;
        this.spinner.show();

        const isRecadastro = this.servico.recadastroId && this.servico.recadastroId !== '00000000-0000-0000-0000-000000000000';
        const id = isRecadastro ? this.servico.recadastroId : this.servico.cadastroId || this.servico.id;
        const adminUsuarioId = this.getAdminUsuarioId();

        if (isRecadastro) {
            this.recadastroService.atribuirRecadastro(id, false).subscribe({
                next: () => {
                    this.servicoService.atualizarStatusRecadastro(id, 'Invalido', this.motivoInvalido, adminUsuarioId).subscribe({
                        next: () => {
                            this.spinner.hide();
                            this.processandoStatus = false;
                            this.statusProcessado = true;
                            try { localStorage.removeItem('servicoAnalise'); } catch (e) { /* ignore */ }
                            setTimeout(() => this.goBack(), 2000);
                        },
                        error: () => {
                            this.spinner.hide();
                            this.processandoStatus = false;
                            this.statusProcessado = false;
                            this.statusFinal = null;
                            alert('Erro ao invalidar vistoria. Tente novamente.');
                        }
                    });
                },
                error: () => {
                    this.spinner.hide();
                    this.processandoStatus = false;
                    this.statusProcessado = false;
                    this.statusFinal = null;
                    alert('Erro ao desatribuir recadastro. Tente novamente.');
                }
            });
        } else {
            this.servicoService.atualizarStatusCadastro(id, 'Invalido', this.motivoInvalido, adminUsuarioId).subscribe({
                next: () => {
                    this.spinner.hide();
                    this.processandoStatus = false;
                    this.statusProcessado = true;
                    try { localStorage.removeItem('servicoAnalise'); } catch (e) { /* ignore */ }
                    setTimeout(() => this.goBack(), 2000);
                },
                error: () => {
                    this.spinner.hide();
                    this.processandoStatus = false;
                    this.statusProcessado = false;
                    this.statusFinal = null;
                    alert('Erro ao invalidar vistoria. Tente novamente.');
                }
            });
        }
    }

    cancelarInvalidacao(): void {
        this.mostrarModalInvalida = false;
        this.motivoInvalido = '';
    }

    iniciarAnalise() {
        if (!this.servico) return;

        const cadastroId = this.tipo === 'recadastro' ? (this.servico.recadastroId || this.servico.id) : (this.servico.cadastroId || this.servico.id);

        const adminUsuarioId = this.getAdminUsuarioId();

        if (!adminUsuarioId) {
            try {
                const mapId = document.getElementById('mapCadastro') ? 'mapCadastro' : (document.getElementById('map-cadastro') ? 'map-cadastro' : null);
                if (!mapId) return;

                const latitudeInicio = parseFloat(this.servico?.latitudeInicio || '0');
                const longitudeInicio = parseFloat(this.servico?.longitudeInicio || '0');
                const latitudeFim = parseFloat(this.servico?.latitudeFim || '0');
                const longitudeFim = parseFloat(this.servico?.longitudeFim || '0');

                const hasInicio = !!(latitudeInicio && longitudeInicio);
                const hasFim = !!(latitudeFim && longitudeFim);

                if (!hasInicio && !hasFim) return;

                const centerLat = hasInicio ? latitudeInicio : latitudeFim;
                const centerLng = hasInicio ? longitudeInicio : longitudeFim;

                const map = L.map(mapId).setView([centerLat, centerLng], 15);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; OpenStreetMap contributors'
                }).addTo(map);

                // Use the same marker icons as roteiro-colaborador
                const inicioIcon = L.icon({
                    iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
                    iconSize: [48, 48],
                    iconAnchor: [24, 48],
                    popupAnchor: [0, -45]
                });

                const fimIcon = L.icon({
                    iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
                    iconSize: [48, 48],
                    iconAnchor: [24, 48],
                    popupAnchor: [0, -45]
                });

                const bounds = L.latLngBounds([]);

                if (hasInicio) {
                    const markerInicio = L.marker([latitudeInicio, longitudeInicio], { icon: inicioIcon }).addTo(map);
                    markerInicio.bindPopup(`<b>Início</b><br/>${this.servico?.horaInicio || ''}<br/>${latitudeInicio}, ${longitudeInicio}`);
                    bounds.extend([latitudeInicio, longitudeInicio]);
                }

                if (hasFim) {
                    const markerFim = L.marker([latitudeFim, longitudeFim], { icon: fimIcon }).addTo(map);
                    markerFim.bindPopup(`<b>Fim</b><br/>${this.servico?.horaFim || ''}<br/>${latitudeFim}, ${longitudeFim}`);
                    bounds.extend([latitudeFim, longitudeFim]);
                }

                if (hasInicio && hasFim) {
                    const latlngs = [[latitudeInicio, longitudeInicio], [latitudeFim, longitudeFim]];
                    const polyline = L.polyline(latlngs, { color: '#3388ff', dashArray: '8,8' }).addTo(map);
                    bounds.extend(latlngs);
                }

                if (bounds.isValid()) {
                    map.fitBounds(bounds.pad(0.2));
                }

                // Allow a bit more time for the container to layout before invalidating size
                setTimeout(() => {
                    try { map.invalidateSize(); } catch (e) { }
                }, 400);

            } catch (error) {
                console.error('Erro ao inicializar mapa da vistoria', error);
            }
        }
    }

    private updateMotivoInvalidoFromMap() {
        const photoCampoKeys = new Set(['FOTO_DOCUMENTO_URL', 'FOTO_CADASTRO_URL']);
        // Only include entries for fields that were explicitly auto-generated/altered
        const entries = Object.keys(this.invalidacaoCampos)
            .filter(k => this.autoGeneratedKeys.has(k) && !photoCampoKeys.has(k))
            .sort()
            .map(campo => {
                const observacao = (this.invalidacaoCampos[campo] || '').trim();
                const labelOverrides: { [k: string]: string } = {
                    'D_UNICA': 'Sub Categoria'
                };
                const label = labelOverrides[campo] || this.humanizeCampo(campo);
                return `${label}: ${observacao}`;
            });

        const current = (this.motivoInvalido || '').trim();
        // Only treat labels derived from auto-generated keys as "auto-lines" to be filtered
        const knownLabels = new Set<string>([...this.autoGeneratedKeys].map(k => this.humanizeCampo(k)));
        const manualLines = current
            .split(/\r?\n/)
            .map(l => l.trim())
            .filter(line => {
                if (!line) return false; // drop empty lines
                // If a line starts with any `Label: ` known for auto-generated keys, skip it (it's an auto-line)
                for (const label of knownLabels) {
                    const prefix = `${label}:`;
                    if (line.toLowerCase().startsWith(prefix.toLowerCase())) return false;
                }
                return true;
            });

        const parts: string[] = [];
        if (manualLines.length) parts.push(manualLines.join('\n'));
        if (entries.length) parts.push(entries.join('\n'));

        // Additionally include any photo/document observations returned by validation endpoints
        const photoObsLines: string[] = [];
        try {
            const fotos = Array.isArray(this.servico?.fotos) ? this.servico.fotos : [];
            fotos.forEach((f: any, idx: number) => {
                const obs = f?.validacao?.observacao || f?.validacao?.Observacao || f?.observacao;
                if (obs && String(obs).trim()) {
                    const idOrUrl = f?.fotoId || f?.id || f?.url || f?.path || `#${idx}`;
                    // label as Foto Cadastro and index starting at 0
                    photoObsLines.push(`Foto Local ${idx}: ${String(obs).trim()}`);
                }
            });

            const docs = Array.isArray(this.servico?.fotosDocumento) ? this.servico.fotosDocumento : [];
            docs.forEach((d: any, idx: number) => {
                const obs = d?.validacao?.observacao || d?.validacao?.Observacao || d?.observacao;
                if (obs && String(obs).trim()) {
                    const idOrUrl = d?.fotoDocumentoId || d?.id || d?.url || d?.path || `#${idx}`;
                    // label as Foto Documento and index starting at 0
                    photoObsLines.push(`Foto Documento ${idx}: ${String(obs).trim()}`);
                }
            });
        } catch (e) {
            // não bloquear montagem do texto se algo falhar ao ler fotos
        }

        if (photoObsLines.length) parts.push(photoObsLines.join('\n'));

        this.motivoInvalido = parts.join('\n\n');
    }

    private humanizeCampo(campo: string) {
        if (!campo) return campo;
        // Basic heuristics: HA_ => Há, underscores -> spaces, words capitalized
        let s = campo.replace(/^HA_/i, 'Há_');
        s = s.replace(/_/g, ' ');
        s = s.toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
        return s;
    }
    maskCpf(cpf: string): string {
    if (!cpf) return '-';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
    maskCnpj(cnpj: any): string {
        if (!cnpj) return '';
        cnpj = String(cnpj).replace(/\D/g, '');
        if (cnpj.length !== 14) return cnpj;
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }


    maskTelefone(telefone: string): string {
        if (!telefone) return '';
        telefone = telefone.replace(/\D/g, '');
        if (telefone.length === 11) {
            return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
        if (telefone.length === 10) {
            return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }
        return telefone;
    }

    servicoYes(value: any): boolean {
        if (value === undefined || value === null) return false;
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value === 1;
        if (typeof value === 'string') {
            const s = value.trim().toLowerCase();
            if (!s) return false;
            return ['true', 'sim', 's', '1', 'yes', 'y'].includes(s);
        }
        return false;
    }

    // Returns true when any of the esgoto-related fields indicate presence.
    hasEsgotoAny(): boolean {
        if (!this.servico) return false;
        const s: any = this.servico;
        // if haColetor exists and is truthy
        if (s.haColetor !== undefined && this.servicoYes(s.haColetor)) return true;
        // check all possible flags
        const flags = ['coletor', 'gap', 'rio', 'valao', 'vala', 'sumidouro', 'focaFiltro'];
        for (const f of flags) {
            if (this.servicoYes(s[f])) return true;
        }
        // tipoValaValao is a textual description - if present, consider it meaningful
        if (s.tipoValaValao) return true;
        return false;
    }

    getTipoServico(registro: any): string {
        return registro && (registro.recadastroId && registro.recadastroId !== '00000000-0000-0000-0000-000000000000') ? 'recadastro' : 'cadastro';
    }

    inicializarMapaServico(): void {
        // Use the same id/name used in templates: prefer 'mapCadastro' (camelCase) but
        // fall back to legacy 'map-cadastro' so other components keep working.
        const mapId = document.getElementById('mapCadastro') ? 'mapCadastro' : (document.getElementById('map-cadastro') ? 'map-cadastro' : null);
        // Remove previous map if any (use a common window var to avoid duplicates)
        if ((window as any)._mapCadastro) {
            try { (window as any)._mapCadastro.remove(); } catch (e) { /* ignore */ }
            (window as any)._mapCadastro = null;
        }

        if (!mapId) return;

        const latInicioRaw = this.servico?.latitudeInicio;
        const lngInicioRaw = this.servico?.longitudeInicio;
        const latFimRaw = this.servico?.latitudeFim;
        const lngFimRaw = this.servico?.longitudeFim;

        const divMapa = document.getElementById(mapId);
        if (!divMapa) return;

        divMapa.innerHTML = '';
        // Prefer the height used in the template
        divMapa.style.height = divMapa.offsetHeight > 0 ? divMapa.offsetHeight + 'px' : '320px';
        divMapa.style.width = '100%';

        const latInicio = latInicioRaw !== undefined && latInicioRaw !== null ? parseFloat(String(latInicioRaw)) : NaN;
        const lngInicio = lngInicioRaw !== undefined && lngInicioRaw !== null ? parseFloat(String(lngInicioRaw)) : NaN;
        const latFim = latFimRaw !== undefined && latFimRaw !== null ? parseFloat(String(latFimRaw)) : NaN;
        const lngFim = lngFimRaw !== undefined && lngFimRaw !== null ? parseFloat(String(lngFimRaw)) : NaN;

        if ((!isNaN(latInicio) && !isNaN(lngInicio)) || (!isNaN(latFim) && !isNaN(lngFim))) {
            try {
                const centerLat = !isNaN(latInicio) ? latInicio : (isNaN(latFim) ? 0 : latFim);
                const centerLng = !isNaN(lngInicio) ? lngInicio : (isNaN(lngFim) ? 0 : lngFim);
                const map = L.map(mapId).setView([centerLat, centerLng], 15);
                (window as any)._mapCadastro = map;

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);

                const bounds = L.latLngBounds([]);

                // Use the same marker icons as roteiro-colaborador for visual consistency
                const inicioIcon = L.icon({
                    iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
                    iconSize: [48, 48],
                    iconAnchor: [24, 48],
                    popupAnchor: [0, -45]
                });

                const fimIcon = L.icon({
                    iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
                    iconSize: [48, 48],
                    iconAnchor: [24, 48],
                    popupAnchor: [0, -45]
                });

                // Marker início
                if (!isNaN(latInicio) && !isNaN(lngInicio)) {
                    try {
                        const inicioMarker = L.marker([latInicio, lngInicio], { icon: inicioIcon }).addTo(map);
                        const dataInicio = this.servico?.dataHoraInicio ? new Date(this.servico.dataHoraInicio).toLocaleString() : 'Data não disponível';
                        inicioMarker.bindPopup(`<strong>Início</strong><br/>Data/Hora: ${dataInicio}<br/>Coord: ${latInicio.toFixed(6)}, ${lngInicio.toFixed(6)}`);
                        bounds.extend([latInicio, lngInicio]);
                    } catch (e) { console.warn('Erro ao adicionar marcador de início', e); }
                }

                // Marker fim
                if (!isNaN(latFim) && !isNaN(lngFim)) {
                    try {
                        const fimMarker = L.marker([latFim, lngFim], { icon: fimIcon }).addTo(map);
                        const dataFim = this.servico?.dataHoraFim ? new Date(this.servico.dataHoraFim).toLocaleString() : 'Data não disponível';
                        fimMarker.bindPopup(`<strong>Fim</strong><br/>Data/Hora: ${dataFim}<br/>Coord: ${latFim.toFixed(6)}, ${lngFim.toFixed(6)}`);
                        bounds.extend([latFim, lngFim]);

                        // Draw a polyline if both points exist and are different
                        if (!isNaN(latInicio) && !isNaN(lngInicio) && (Math.abs(latInicio - latFim) > 0.000001 || Math.abs(lngInicio - lngFim) > 0.000001)) {
                            L.polyline([[latInicio, lngInicio], [latFim, lngFim]], { color: '#3388ff', weight: 3, opacity: 0.6, dashArray: '8,8' }).addTo(map);
                        }
                    } catch (e) { console.warn('Erro ao adicionar marcador de fim', e); }
                }

                if (bounds.isValid()) {
                    map.fitBounds(bounds, { padding: [20, 20] });
                }

                // invalidateSize after a short delay so tiles render correctly
                setTimeout(() => { try { map.invalidateSize(); } catch (e) { /* ignore */ } }, 300);
            } catch (error) {
                console.error('Erro ao inicializar mapa:', error);
            }
        }
    }

    exportarServicoParaPDF(): void {
        if (!this.servico) return;

        const containerSelector = '.servico-detalhes-content';
        let original = document.querySelector(containerSelector) as HTMLElement | null;
        if (!original) original = document.querySelector('.main-container') as HTMLElement | null;
        if (!original) {
            alert('Conteúdo para exportar não encontrado.');
            return;
        }

        // Clone the node so we don't affect the visible page
        const clone = original.cloneNode(true) as HTMLElement;
        // Ensure cloned node is visible, full-width and off-screen
        clone.style.position = 'absolute';
        clone.style.top = '-99999px';
        clone.style.left = '-99999px';
        clone.style.width = original.offsetWidth + 'px';
        clone.style.maxWidth = original.offsetWidth + 'px';
        clone.style.overflow = 'visible';
        clone.style.visibility = 'visible';
        clone.style.pointerEvents = 'none';

        // Append clone to body
        document.body.appendChild(clone);

        // Wait for images to load inside the clone (helps html2canvas capture them)
        const images = Array.from(clone.querySelectorAll('img')) as HTMLImageElement[];
        const waitForImages = images.map(img => new Promise<void>((resolve) => {
            if (!img.src) return resolve();
            if (img.complete) return resolve();
            img.onload = () => resolve();
            img.onerror = () => resolve();
        }));

        Promise.all(waitForImages).then(() => {
            // Use a reasonable scale for clarity, but keep memory in check
            const scale = Math.min(2, window.devicePixelRatio || 1);

            html2canvas(clone, { scale, useCORS: true, backgroundColor: '#ffffff', allowTaint: true })
                .then((canvas: HTMLCanvasElement) => {
                    try {
                        // remove clone asap
                        if (document.body.contains(clone)) document.body.removeChild(clone);

                        const pdf = new jsPDF('p', 'mm', 'a4');
                        const pdfWidth = 210; const pdfHeight = 297; const margin = 8;
                        const contentWidth = pdfWidth - margin * 2;

                        // Convert canvas to image and calculate dimensions on PDF
                        const imgWidth = contentWidth;
                        const imgHeight = (canvas.height * imgWidth) / canvas.width;

                        // Determine how many pages are needed
                        const pageContentHeight = pdfHeight - margin * 2;
                        const pxPerPage = Math.floor((canvas.height * (pageContentHeight / imgHeight)));

                        let rendered = 0;
                        let page = 0;

                        while (rendered < canvas.height) {
                            const sliceHeight = Math.min(pxPerPage, canvas.height - rendered);
                            const pageCanvas = document.createElement('canvas');
                            pageCanvas.width = canvas.width;
                            pageCanvas.height = sliceHeight;
                            const ctx = pageCanvas.getContext('2d');
                            if (!ctx) break;
                            ctx.drawImage(canvas, 0, rendered, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);
                            const imgData = pageCanvas.toDataURL('image/png');

                            const renderedImgHeight = (sliceHeight * imgWidth) / canvas.width;
                            if (page > 0) pdf.addPage();
                            pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, renderedImgHeight);

                            rendered += sliceHeight;
                            page++;
                        }

                        const nome = (this.servico?.nomeConsumidor || 'servico').toString().replace(/\s+/g, '_');
                        pdf.save(`${nome}_servico.pdf`);
                    } catch (e) {
                        console.error('Erro ao processar PDF', e);
                        alert('Erro ao gerar o PDF. Tente novamente.');
                    }
                }).catch((err: any) => {
                    if (document.body.contains(clone)) document.body.removeChild(clone);
                    console.error('html2canvas falhou', err);
                    alert('Erro ao gerar o PDF. Tente novamente.');
                });
        }).catch(() => {
            if (document.body.contains(clone)) document.body.removeChild(clone);
            alert('Erro ao carregar imagens para exportação. Tente novamente.');
        });
    }

    getAdminUsuarioId(): string {
        try {
            const triedKeys = ['usuarioId'];
            const candidates: string[] = [];

            for (const key of triedKeys) {
                const raw = localStorage.getItem(key);
                if (!raw) continue;
                // se raw parecer um JSON, parseie e procure propriedades comuns
                const looksLikeJson = raw.trim().startsWith('{') || raw.trim().startsWith('[');
                if (looksLikeJson) {
                    try {
                        const obj = JSON.parse(raw);
                        const possible = [
                            obj.usuarioId, obj.userId, obj.id, obj.idUsuario, obj.usuarioid,
                            // também campos dentro de obj.usuario
                            obj.usuario && (obj.usuario.usuarioId || obj.usuario.id || obj.usuario.userId || obj.usuario.idUsuario)
                        ];
                        for (const p of possible) {
                            if (p) candidates.push(String(p));
                        }
                    } catch (e) {
                        // se parse falhar, ignore e continue
                    }
                } else {
                    // valor simples: pode ser o id direto
                    if (raw && raw.trim()) {
                        candidates.push(raw.trim());
                    }
                }
            }

            // retorna primeiro candidato válido
            if (candidates.length) return candidates[0];

            return '';
        } catch (e) {
            return '';
        }
    }
}